import type { PayrollTierId } from '../../config/countries';
import type { TierMetaEntry } from './types';

export const TIER_META: Record<PayrollTierId, TierMetaEntry> = {
  core: { order: 1, ribbon: { key: "starter", bg: "#6B7280" }, nameBadgeBg: "#F3F4F6", nameBadgeColor: "#374151", featured: false },
  premium: { order: 2, ribbon: { key: "mostPopular", bg: "#046A38" }, nameBadgeBg: "#E7F5EF", nameBadgeColor: "#046A38", featured: true },
  elite: { order: 3, ribbon: { key: "multiLocation", bg: "#0E1A1A" }, nameBadgeBg: "#F3F4F6", nameBadgeColor: "#374151", featured: false },
};
